import axios from 'axios'
import config from './ambiente'
let querystring = require('querystring')
// import mockForm from '../mock-formulario'

const baseUrl = config.apiUrlBase
const relatorioUrlBase = config.relatorioUrlBase

const headerFormUrlEnconded = {
  //'Content-Type': 'application/x-www-form-urlencoded'
}

async function recusarTermoFormulario(formularioId,pessoaId, termoId) {
  
  let result = null;
  const formuarioRecusa = {
    formularioId,
    pessoaId,
    termoId
  }

  try {
    const response = await axios.post(`${baseUrl}formularios/${formularioId}/RecusarTermo`, formuarioRecusa, headerFormUrlEnconded);
    result = { sucesso: true, interacaoFormularioId: response.data }
  } catch (err) {
    const { erros } = err.response.data
    result = { sucesso: false, erros: erros.map(e => e.mensagem) };
  }

  return result;
}

async function aplicarPosValidacao(codigoCliente, interacaoFormularioId){
  let result = null;

  try {
    const response = await axios.get(`${baseUrl}posvalidacoes/${codigoCliente}/interacaoFormulario/${interacaoFormularioId}`);
    result = { sucesso: true, ...response.data }
  } catch (err) {
    const { erros } = err.response.data
    result = { sucesso: false, erros: erros.map(e => e.mensagem) };
  }

  return result;
}

async function obterFormularioPorId(payloadFormulario) {
  const {formularioId, codigoCliente} = payloadFormulario;  
  const result = await axios.get(`${baseUrl}formularios/${formularioId}/cliente/${codigoCliente}`)
  const formulario = result.data;
  return formulario
}

async function obterFormularioAssistidoPorId(payloadFormulario) {
  const {formularioId, codigoCliente,pessoaId} = payloadFormulario;  
  const result = await axios.get(`${baseUrl}formularios/${formularioId}/cliente/${codigoCliente}/pessoa/${pessoaId}/assistido`)
  const formulario = result.data;
  return formulario
}

async function responderFormulario(formuarioResposta) {
  const { formularioId } = formuarioResposta;
  let result = null;

  try {
    const response = await axios.post(`${baseUrl}formularios/${formularioId}/responder`, formuarioResposta, headerFormUrlEnconded);
    result = { sucesso: true, interacaoFormularioId: response.data }
  } catch (err) {
    const { erros } = err.response.data
    result = { sucesso: false, erros: erros.map(e => e.mensagem) };
  }

  return result;
}

async function obterApuracao(formularioId) {
  let dados = { opcao: 'resultadoParcial', formularioId }
  dados = querystring.stringify(dados)
  let result = await axios.post(baseUrl, dados, headerFormUrlEnconded)

  return result.data
}

async function obterFormularios() {
  let dados = { opcao: 'obterFormularios' }
  dados = querystring.stringify(dados)
  let result = await axios.post(baseUrl, dados, headerFormUrlEnconded)
  return result.data
}

async function verificarRespostaFormulario(formularioId, identificador) {
  let dados = { opcao: 'respondeuFormulario', formularioId, identificador }
  dados = querystring.stringify(dados)
  let result = await axios.post(baseUrl, dados, headerFormUrlEnconded)
  return result.data
}

async function inativarFormulario(formularioId) {
  let formulario = JSON.stringify({ formularioId })
  let dados = { opcao: 'inativarFormulario', formulario: formulario }
  dados = querystring.stringify(dados)
  let result = await axios.post(baseUrl, dados, headerFormUrlEnconded)
  let { sucesso } = result.data
  return sucesso
}

function gerarDadosRelatorioFormulario(formularioId) {
  return axios.get(`${relatorioUrlBase}?formId=${formularioId}`)
}

export default {
  obterFormularioPorId,
  obterFormularioAssistidoPorId,
  responderFormulario,
  obterApuracao,
  obterFormularios,
  inativarFormulario,
  gerarDadosRelatorioFormulario,
  verificarRespostaFormulario,
  aplicarPosValidacao,
  recusarTermoFormulario
}



// WEBPACK FOOTER //
// ./src/services/FormularioService.js